import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSalesPlansAnalytics } from '../useSalesPlansAnalytics';
import { MonthlyPlansContainer } from './MonthlyPlansContainer';
import { monthlyPlansStore } from '../model';

export const MonthlyPlansWrapper = observer(() => {
  const { data, isLoading } = useSalesPlansAnalytics();

  if (monthlyPlansStore.isHiddenPermanently) {
    return null;
  }

  if (isLoading) {
    return null;
  }

  if (!data?.salesPlans) {
    return null;
  }

  return (
    <MonthlyPlansContainer
      visible={data.salesPlans.showPlan}
      branch={data.salesPlans.branch}
      data={{
        profit: data.salesPlans.profit,
        revenue: data.salesPlans.revenue,
      }}
    />
  );
});
